<template>
    <div class="rfq">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>询价单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>询价单管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="公司">
                        <el-select v-model="searchForm.companyId" filterable clearable placeholder="请选择公司" size="mini">
                            <el-option
                                v-for="item in companyOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户邮箱">
                        <el-input v-model="searchForm.userEmail" placeholder="用户邮箱" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户名称">
                        <el-input v-model="searchForm.userName" placeholder="用户名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.process" placeholder="询报价单审核状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待分配供应商" value="1"></el-option>
                            <el-option label="待供应商报价" value="2"></el-option>
                            <el-option label="等待业务员报价" value="3"></el-option>
                            <el-option label="等待业务经理审核" value="4"></el-option>
                            <el-option label="驳回" value="5"></el-option>
                            <el-option label="通过" value="6"></el-option>
                            <el-option label="下单" value="7"></el-option>
                            <el-option label="发货" value="8"></el-option>
                            <el-option label="收货" value="9"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                 <el-table
                    size="mini"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column
                        fixed="left"
                        prop="id"
                        label="询价单编号" width="250">
                    </el-table-column>
                    <el-table-column
                        prop="companyName"
                        label="公司名称" width="300">
                    </el-table-column>
                    <el-table-column
                        prop="userEmail"
                        label="用户邮箱" width="300">
                    </el-table-column>
                    <el-table-column
                        prop="userName"
                        label="用户名称" width="120">
                    </el-table-column>
                    <el-table-column
                        prop="itemNum"
                        label="商品种类数量" width="150" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="answerItemNum"
                        label="已报价商品种类数量" width="150" align="center">
                    </el-table-column>
                     <el-table-column
                            prop="createTime"
                            label="创建时间" width="200" align="center">
                     </el-table-column>
                     <el-table-column
                             prop="deadline"
                             label="报价截止日期" width="200" align="center">
                     </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注" width="300">
                    </el-table-column>
                     <el-table-column
                            fixed="right"
                            prop="status"
                            label="状态"
                            width="100" align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.process == 0">待分配业务员</el-tag>
                            <el-tag v-if="scope.row.process == 1">待分配供应商</el-tag>
                            <el-tag v-if="scope.row.process == 2">待供应商报价</el-tag>
                            <el-tag v-if="scope.row.process == 3">等待业务报价</el-tag>
                            <el-tag v-if="scope.row.process == 4">等待审核</el-tag>
                            <el-tag v-if="scope.row.process == 5">驳回</el-tag>
                            <el-tag v-if="scope.row.process == 6">通过</el-tag>
                            <el-tag v-if="scope.row.process == 7">下单</el-tag>
                            <el-tag v-if="scope.row.process == 8">发货</el-tag>
                            <el-tag v-if="scope.row.process == 9">收货</el-tag>
                         </template>
                     </el-table-column>
                    <el-table-column label="操作" width="350" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text"
                                    size="mini"
                                    @click="handleEditPrice(scope.$index, scope.row)">详情</el-button>
                            <el-divider direction="vertical" v-if="scope.row.process <= 2" ></el-divider>
                            <el-button type="text"
                                size="mini" v-if="scope.row.process <= 2"
                                @click="handleEdit(scope.$index, scope.row)">报价截止日期</el-button>
                            <el-divider direction="vertical" v-if="scope.row.process == 3 || scope.row.process == 5"></el-divider>
                            <el-button type="text"
                                size="mini" v-if="scope.row.process == 3 || scope.row.process == 5"
                                @click="handleToReview(scope.$index, scope.row)" >提交审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="派发询价单" :visible.sync="editSupplier" :close-on-click-modal="false" width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="60px">
                <el-form-item label="业务员" prop="sendId">
                    <el-select v-model="editForm.sendId" filterable placeholder="请选择业务员" clearable>
                        <el-option v-for="item in staffs" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editSupplier = false">取 消</el-button>
                <el-button type="primary" @click="onSendTo">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="询价单信息" :visible.sync="editDialogVisible" :before-close="handleClose"  width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px">
                <el-form-item label="询价单编号">
                    <el-input v-model="editForm.id" :disabled="true"  placeholder="请输入名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="报价截止时间" prop="deadline">
                    <el-date-picker
                            v-model="editForm.deadline"
                            type="date" :picker-options="pickerOptions"
                            placeholder="供应商报价截止时间" value-format="yyyy-MM-dd"
                            clearable
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                companyId: "",
                userName: "",
                userEmail: "",
                process: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            authDialogVisible: false,
            uploadDialogVisible: false,
            fileList: [],
            editForm: {
                id: "",
                name: "",
                userId: "",
                userName: "",
                userEmail: "",
                remark: "",
                url: "",
                status: "",
                filePath: "",
                file:"",
                sendId:"",
                deadline:"",
            },
            rules: {
                name: [
                    { required: true, message: '请输入询价单名称', trigger: 'blur' }
                ],
                userId: [
                    { required: true, message: '请选择用户', trigger: 'blur' }
                ]
            },
            staffs: [],//可选的派发的供应商
            companyOptions: [],
            editSupplier: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            }
        }
    },
    methods: {
        onSearch() {

                this.loading = true;
                let _this = this
                let cond = {...this.searchForm};
                if(!this.searchForm.process) {
                    cond['process'] = undefined;
                }
                this.$axios.post("/admin/rfq/searchRfqMgn",{
                    cond,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function(response) {
                    let resp = response.data;
                    if( resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function() {
                });


        },
        onSubmit() {
            if(this.editForm.deadline== null){
                this.$notify.warning({
                    title: '提示',
                    message: "请先设置报价截止日期"
                });
                return;
            }
            let _this = this;
            this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$axios.post("/admin/rfq/saveDate",{id:this.editForm.id,deadline:this.editForm.deadline} )
                            .then(function (response) {
                                let resp = response.data;
                                if (resp.header.status == 0) {
                                    _this.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    _this.editDialogVisible = false;
                                    _this.authDialogVisible = false;
                                    _this.onSearch();
                                } else {
                                    _this.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                }
                            });
                    }
            })
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEditPrice(index, row) {
            this.$router.push({name: "rfqdetailMgn", params: {from: "rfq", rfqId: row.id,title:'报价录入',info:row.id}})
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.deadline = row.deadline;
            this.editDialogVisible = true;
        },
        handleSupplier(index, row) {
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.userId = row.userId;
            this.editForm.userName = row.userName;
            this.editForm.remark = row.remark;
            this.editForm.filePath = row.filePath;
            this.editForm.status = row.status + "";
            this.editForm.sendId = "",
            this.editSupplier = true;
        },
        handleAuth(index, row) {
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.userId = row.userId;
            this.editForm.userName = row.userName;
            this.editForm.remark = row.remark;
            this.editForm.filePath = row.filePath;
            this.editForm.status = row.status + "";
            this.authDialogVisible = true;
        },
        handleUpload(index, row) {
            this.editForm.id = row.id;
            this.uploadDialogVisible = true;
        },
        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除询价单【' + row.name + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/rfq/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        // 文件状态改变时的钩子
        fileChange(file) {
            this.editForm.file = file.raw
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {

            let extension = file.name.substring(file.name.lastIndexOf('.')+1)
            let size = file.size / 1024 / 1024
            if(extension !== 'xlsx') {
                this.$notify.warning({
                    title: '警告',
                    message: `只能上传Excel2017（即后缀是.xlsx）的文件`
                });
            }
            if(size > 10) {
                this.$notify.warning({
                    title: '警告',
                    message: `文件大小不得超过10M`
                });
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file) {
            this.$notify.success({
                title: '成功',
                message: `文件上传成功`
            });
            if (file.response.data.success) {
                this.editForm.filePath = file.response.data.message; //将返回的文件储存路径赋值picture字段
            }
        },
        // 文件上传失败时的钩子
        handleError() {
            this.$notify.error({
                title: '错误',
                message: `文件上传失败`
            });
        },
        initStaffs() {//加载供应商
            let _this = this;
            this.$axios.post("/admin/rights/staff/list",{type:1})
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.staffs.length = 0;
                        for(let i=0; i<resp.data.length; i++) {
                            let data = resp.data[i];
                            _this.staffs.push({
                                label: data.name,
                                value: data.id,
                            })
                        }

                    }
                })

        },
        onSendTo() {
            let that = this;
            this.$axios.post("/admin/rfq/assignCS",{
                rfqId: this.editForm.id,
                csId: this.editForm.sendId,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '派发询价单成功',
                        type: 'success'
                    });
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
                that.editSupplier = false;
            })


        },
        initCompanyOption() {
            let that = this;
            this.$axios.post("/admin/company/list", {}).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                that.companyOptions = resp.data;
                } else {
                that.$notify.error({
                    title: '错误',
                    message: resp.header.msg
                });
                }
            });
        },
        handleToReview(index, row) {
            let that = this;
            this.$confirm('是确认提交报价信息？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.post("/admin/quote/csQuoteToReview",{ids: [row.id]} )
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status === 0) {
                            that.$notify({
                                title: '成功',
                                message: '提交报价成功',
                                type: 'success'
                            });
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.initStaffs();
        this.initCompanyOption();
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
